import { useUser } from '~/app/contexts/UserContext';
import { RouteObject } from '~/app/types';
import { EAnalyticsEvents } from '~/shared/enums';
import { mixPanel } from '~/shared/lib/mixpanel';

export function useNavAnalytics() {
  const user = useUser();

  const fireMenuItemClick = (item: RouteObject) => {
    mixPanel.fireEvent({
      event: EAnalyticsEvents.NAV_MENU_CLICK,
      user,
      properties: { menuItem: item.key },
    });
  };

  return { fireMenuItemClick };
}
